module.exports = __webpack_public_path__ + "img/truck-location-cluster.eba41bdc.svg";